// import "./LeadershipPage.css";
// import React, { useRef, useEffect, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import Modal3 from "../../components/Modal3";
// const LeadershipPage = () => {

//   const [modalOpen, setModalOpen] = useState(false);

//   const openModal = () => {
//     setModalOpen(true);
//   };

//   const closeModal = () => {
//     setModalOpen(false);
//   };
//   const [modalOpen2, setModalOpen2] = useState(false);

//   const openModal2 = () => {
//     setModalOpen2(true);
//   };

//   const closeModal2 = () => {
//     setModalOpen2(false);
//   };
//   const [modalOpen3, setModalOpen3] = useState(false);

//   const openModal3 = () => {
//     setModalOpen3(true);
//   };

//   const closeModal3 = () => {
//     setModalOpen3(false);
//   };

//   return (
//     <div>
//       <div className="hero_title hero_title_clr">Our Leadership Team</div>
//       <div className="hero_img leadership_mobile_img">
//         <img src="/assets/leadimg1.jpg" className="lpageImg" alt="" />
//       </div>
//       <div className="container_led">
//         <div className="lpage_heading1">
//           <h3>Board of Directors</h3>
//         </div>

//         <div className="lpage_divl">
//         <Link onClick={openModal}>
//         <div className="lpage_div12" >
//             <img src="/assets/leadimg2.jpg" alt="" />
//             <div className="lpage_div1_title">
//               <span>Mihir Nerurkar</span>
//               <p>MD & COO India</p>
//               <p>Brookfield Infrastructure Group</p>
//             </div>
//           </div>
//         </Link>
//         <Link onClick={openModal2}>
//         <div className="lpage_div12">
//             <img src="/assets/leadimg3.jpg" alt="" />
//             <div className="lpage_div1_title">
//               <span>Arushi Jamar</span>
//               <p>Senior Associate</p>
//               <p>Brookfield Infrastructure Group</p>
//             </div>
//           </div>
//         </Link>
//           <Link onClick={openModal3}>
//           <div className="lpage_div13">
//             <img src="/assets/leadimg4.jpg" alt="" />
//             <div className="lpage_div1_title">
//               <span>Gaurav Chowdhary</span>
//               <p>Vice President Investments</p>
//               <p>Brookfield Advisors India Pvt Ltd</p>
//             </div>
//           </div>
//           </Link>

//         </div>
//         <div className="lpage_heading1">
//           <h3>Leadership Team</h3>
//         </div>

//         <div className="lpage_div12">
//           <img src="/assets/leadimg5.jpg" alt="" />
//           <div className="lpage_div1_title">
//             <span>Sanjay Nandrajog</span>
//             <p>Chief Executive Officer</p>
//           </div>
//         </div>

//         <div className="lpage_divl">
//           <div className="lpage_div12">
//             <img src="/assets/leadimg6.jpg" alt="" />
//             <div className="lpage_div1_title">
//               <span>Pankaj Malik</span>
//               <p>Chief Operating Officer</p>
//             </div>
//           </div>
//           <div className="lpage_div12">
//             <img src="/assets/leadimg7.jpg" alt="" />
//             <div className="lpage_div1_title">
//               <span>Vineet Sirpaul</span>
//               <p>Chief Corporate Sales and Acquisition</p>
//               <p>Officer</p>
//             </div>
//           </div>
//           <div className="lpage_div13">
//             <img src="/assets/leadimg8.jpg" alt="" />
//             <div className="lpage_div1_title">
//               <span>Kousik Gupta</span>
//               <p>Chief Technology Officer</p>
//             </div>
//           </div>
//         </div>

//         <div className="lpage_divl">
//           <div className="lpage_div12">
//             <img src="/assets/leadimg9.jpg" alt="" />
//             <div className="lpage_div1_title">
//               <span>Rakesh Ladha</span>
//               <p>Chief Financial Officer</p>
//             </div>
//           </div>
//           <div className="lpage_div12">
//             <img src="/assets/leadimg10.jpg" alt="" />
//             <div className="lpage_div1_title">
//               <span>Dolly Grover</span>
//               <p>Chief Human Resource Officer</p>
//             </div>
//           </div>
//           <div className="lpage_div13">
//             <img src="/assets/leadimg11.jpg" alt="" />
//             <div className="lpage_div1_title">
//               <span>Amit Raman Jha</span>
//               <p>Chief Supply Chain Officer</p>
//             </div>
//           </div>
//         </div>
//       </div>
//       {modalOpen && <Modal3  closeModal={closeModal} name={'Mihir Nerurkar'} img={'/assets/leadimg2.jpg'} title={'MD COO India\nBrookfield Infrastructure Group'} about={' Mihir Nerurkar is the Managing Director and Operating Partner, of Brookfield’s Infrastructure Group for India. In this role, he oversees operations of all infrastructure assets and the overall performance of Brookfield’s infrastructure portfolio companies in India. Mr. Nerurkar joined Brookfield in 2018 with over 20 years of experience across the financial services, real estate, and infrastructure sectors. He began his career as a Management Consultant with Deloitte Consulting in New York and subsequently held roles as Chief Operating Officer and Senior Director at a real estate firm, as well as served as an Advisory Board Member of a boutique investment bank.\n\nHe holds a Bachelor of Engineering from Pune University in India and a Master’s from Syracuse University'}/>}
//       {modalOpen2 && <Modal3  closeModal={closeModal2} name ={'Arushi Jamar'} img={'/assets/leadimg3.jpg'} title={'Senior Associate\nBrookfield Infrastructure Group'} about={'Arushi Jamar is a Senior Associate at Brookfield’s Infrastructure Group. She is a part of the team managing the investment activity in India & Middle East. In this role, she has been part of Brookfield’s investments in telecom towers, In-building solutions, natural gas pipeline, data centers and smart meters in India and Australia. Prior to joining Brookfield, Arushi was a part of the Investment Banking team at Moelis & Company’s Mumbai office.\nArushi holds a master’s in management from IIM Ahmedabad and a bachelor’s in financial and Investment Analysis from the University of Delhi.'}/>}
//       {modalOpen3 && <Modal3  closeModal={closeModal3} name ={'Gaurav Chowdhary'} img={'/assets/leadimg4.jpg'} title={'Vice President Investments\nBrookfield Advisors India Pvt Ltd'} about={'Gaurav Chowdhary is a Vice President of Brookfield’s Infrastructure Group. He is a part of the team managing the investment activity in India & Middle East. Mr. Chowdhary has completed his PGDBM from XLRI Jamshedpur and a Bachelor’s degree from IIT Kharagpur.'}/>}
//       {/* {modalOpen && <Modal3  closeModal={closeModal} name ={} img={} title={} about={}/>} */}

//     </div>
//   );
// };
// export default LeadershipPage;
import "./LeadershipPage.css";
import React, { useRef, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Modal3 from "../../components/Modal3";

const LeadershipPage = () => {
  const modalData = [
    {
      name: "Mihir Nerurkar",
      img: "/assets/limg1.jpg",
      title: "MD COO India\nBrookfield Infrastructure Group",
      about:
        "Mihir Nerurkar is the Managing Director and Operating Partner, of Brookfield’s Infrastructure Group for India. In this role, he oversees operations of all infrastructure assets and the overall performance of Brookfield’s infrastructure portfolio companies in India. Mr. Nerurkar joined Brookfield in 2018 with over 20 years of experience across the financial services, real estate, and infrastructure sectors. He began his career as a Management Consultant with Deloitte Consulting in New York and subsequently held roles as Chief Operating Officer and Senior Director at a real estate firm, as well as served as an Advisory Board Member of a boutique investment bank.\n\nHe holds a Bachelor of Engineering from Pune University in India and a Master’s from Syracuse University",
    },
    {
      name: "Arushi Jamar",
      img: "/assets/limg2.jpg",
      title: "Senior Associate\nBrookfield Infrastructure Group",
      about:
        "Arushi Jamar is a Senior Associate at Brookfield’s Infrastructure Group. She is a part of the team managing the investment activity in India & Middle East. In this role, she has been part of Brookfield’s investments in telecom towers, In-building solutions, natural gas pipeline, data centers and smart meters in India and Australia. Prior to joining Brookfield, Arushi was a part of the Investment Banking team at Moelis & Company’s Mumbai office.\n\nArushi holds a master’s in management from IIM Ahmedabad and a bachelor’s in financial and Investment Analysis from the University of Delhi.",
    },
    {
      name: "Gaurav Chowdhary",
      img: "/assets/limg3.jpg",
      title: "Vice President Investments\nBrookfield Advisors India Pvt Ltd",
      about:
        "Gaurav Chowdhary is a Vice President of Brookfield’s Infrastructure Group. He is a part of the team managing the investment activity in India & Middle East. Mr. Chowdhary has completed his PGDBM from XLRI Jamshedpur and a Bachelor’s degree from IIT Kharagpur.",
    },
    {
      name: "Sanjay Nandrajog",
      img: "/assets/limg4.jpg",
      title: "CHIEF EXECUTIVE OFFICER",
      about:
        "Sanjay Nandrajog is the Chief Executive Officer at Crest Digitel Private Limited.\n\nSanjay is a seasoned Professional with over 36 years of experience across the Consumer, Telecom, Restaurant, Agri-business & Social Entrepreneurship sectors. He has been associated with strategic leadership roles in Bharti, PepsiCo, ICI, Tatas & SREI at CEO/Director levels. He has been responsible for the successful ramp-up of large businesses in high-growth sectors like Telecom & Beverages achieving strong market leadership and launching international brands like Del Monte and PizzaExpress in India.\n\nHe is an alumnus of IIT Delhi and IIM Kolkata.",
    },
    {
      name: "Pankaj Malik",
      img: "/assets/limg5.jpg",
      title: "CHIEF OPERATING OFFICER",
      about:
        "Pankaj Malik is the Chief Operating Officer at Crest Digitel Private Limited.\n\nPankaj is an astute professional with 25 years of experience in diverse sectors across Consumer Durables, Telecom, Security & Surveillance and has expertise in domains of P&L handling, General Management and Change Management. During his Telecom stint, he was instrumental in launching the First 4G Circle Services in India and has been associated as Director / Business Head for the last 10 years with globally recognized Conglomerates like Bharti Airtel, Vodafone Idea Limited, Phillips & G4S Securities. He has also proficiently led Client programs partnering with global giants like Amazon, Microsoft & Google\n\nHe is a Commerce graduate from Delhi University and has done his Master’s program in International Marketing in association with IIFT.",
    },
    {
      name: "Vineet Sirpaul",
      img: "/assets/limg6.jpg",
      title: "CHIEF CORPORATE SALES AND\nACQUISITION OFFICER",
      about:
        "Vineet Sirpaul is the Chief Corporate Sales and Acquisition Officer at Crest Digitel Private Limited.\n\nVineet heads Corporate Sales, Strategic Partnerships, and the Institutional business. He has over 28 years of telecom experience in Sales, Business Transformation, Supply Chain Management, Turnkey Projects, Manpower Outsourcing, and Business Development across Tata Communications, Nutek India Limited, and Lucent Technologies. He is also a member of the GLG council and provides honorary expert advice on the telecom Infrastructure industry. He has a degree in B.E from the University of Mumbai and has done his Post Graduate Diploma in Business Management from IILM Delhi.",
    },
    {
      name: "Kousik Gupta",
      img: "/assets/limg7.jpg",
      title: "CHIEF TECHNOLOGY OFFICER",
      about:
        "Kousik Gupta is the Chief Technology Officer of Crest Digitel Private Limited.\n\nKousik is a Telecom professional with more than 31 years of experience and has worked across geographies as CTO, Head Planning & Project Management, and Head Network Integration in Telecom Operators like Airtel, Reliance, and Idea Cellular. He was also associated with Alcatel Lucent and CCI, Canada for Indian & Overseas assignments in Technology & Business Development roles. In a brief stint in Andrew Yule, he engaged with leading Government customers like BSNL/MTNL, Railways, GAIL, ONGC & Coal India. He has rich experience in Mobility Technologies 2G, 3G & 4G extensively in the RF, MW, and Fibre Transmission domains. He has been responsible for many successful launches of Mobile services and the merger of Tata & Telenor with the Airtel network.\n\nHe is a graduate of Kolkata University and has done his post-graduation in Telecom Management from ICFAI University.",
    },
    {
      name: "Rakesh Ladha",
      img: "/assets/limg8.jpg",
      title: "CHIEF FINANCIAL OFFICER",
      about:
        "Rakesh Laddha is the Chief Financial Officer of Crest Digitel Private Limited.\n\nRakesh is a Seasoned Professional, with over 26 years of extensive exposure in Strategy Designing, Mergers and Acquisitions, Deal Closure and Post Deal Integration, Treasury, Process Engineering, Audits, Budgeting & ERP implementation across varied industries like Telecom, Healthcare, Real Estate, Power, Metal and Hospitality in both established and start-up environments. He has worked in organizations like Fortis Healthcare, Unitech, Monnet Power, Vedanta, and Grasim Industries.\n\nHe is a Rank holder Chartered Accountant.",
    },

    {
      name: "Dolly Grover",
      img: "/assets/limg9.jpg",
      title: "CHIEF HUMAN RESOURCE OFFICER",
      about:
        "Dolly Grover is the Chief Human Resources Officer at Crest Digitel Private Limited.\n\nDolly brings with her over 30 years of rich and diverse experience in creating Employee Value Propositions, Branding, and CSR. She has varied experience across the Telecommunications, Foods & Beverages, IT, and Paper industries. Having worked with renowned organizations & brands like Del Monte, Airtel, Alcatel, and Ballarpur Industries, she has worked in various capacities in the HR function and has been in a leadership role for more than a decade. She has played a key role in formulating people strategy, planning & execution for the start-up.\n\nShe is a Certified Leadership Coach (CLC) accredited with International Coaching Federation, USA. She had done her graduation with a Bachelor of Science from Delhi University and an M.S.W from Delhi School of Social Work as well as a Post Graduate Diploma in Personnel Management and Industrial Relations from Bhartiya Vidya Bhawan.",
    },

    {
      name: "Amit Raman Jha",
      img: "/assets/limg10.jpg",
      title: "CHIEF SUPPLY CHAIN OFFICER",
      about:
        "Amit Raman Jha is the Chief Supply Chain Officer at Crest Digitel Private Limited.\n\nAmit is a seasoned Supply Chain and Business Professional with 20 years of experience across the industry.\n\nHis Prior experience has been with Bharti Airtel Limited in different leadership Positions for more than a decade across the geography.\n\nAmit is an Alumni of the Prestigious Institution of the Armed Forces “ The CMM”, Jabalpur, and IIM Kolkata.",
    },
    {
      name: "Amit Raman Jha",
      img: "/assets/leadimg4.jpg",
      title: "CHIEF FINANCIAL OFFICER",
      about: "",
    },
  ];

  const [modals, setModals] = useState([]);

  useEffect(() => {
    setModals(modalData.map((modal) => ({ ...modal, isOpen: false })));
  }, []);

  const setModalState = (index, isOpen) => {
    const updatedModals = [...modals];
    updatedModals[index].isOpen = isOpen;
    setModals(updatedModals);
  };

  const openModal = (index) => {
    setModalState(index, true);
  };

  const closeModal = (index) => {
    setModalState(index, false);
  };

  return (
    <div>
      <div className="hero_img leadership_mobile_img">
        <img src="/assets/leadimg1.jpg" className="lpageImg" alt="" />
        {/* <img
          src="	https://www.crestdigitel.com/wp-content/uploads/2022/12/leadership_banner.jpg"
          className="lpageImg"
          alt=""
        /> */}
        <div className="hero_title hero_title_clr">Our Leadership Team</div>
      </div>
      <div className="container_led">
        <div className="lpage_heading1">
          <h3>Board of Directors</h3>
        </div>

        <div className="lpage_divl">
          <Link onClick={() => openModal(0)}>
            <div className="lpage_div12">
              <img src="/assets/leadimg2.jpg" alt="" />
              <div className="lpage_div1_title">
                <span>Mihir Nerurkar</span>
                <p>MD & COO India</p>
                <p>Brookfield Infrastructure Group</p>
              </div>
            </div>
          </Link>
          <Link onClick={() => openModal(1)}>
            <div className="lpage_div12">
              <img src="/assets/leadimg3.jpg" alt="" />
              <div className="lpage_div1_title">
                <span>Arushi Jamar</span>
                <p>Senior Associate</p>
                <p>Brookfield Infrastructure Group</p>
              </div>
            </div>
          </Link>
          <Link onClick={() => openModal(2)}>
            <div className="lpage_div13">
              <img src="/assets/leadimg4.jpg" alt="" />
              <div className="lpage_div1_title">
                <span>Gaurav Chowdhary</span>
                <p>Vice President Investments</p>
                <p>Brookfield Advisors India Pvt Ltd</p>
              </div>
            </div>
          </Link>
        </div>

        <div className="lpage_heading1">
          <h3>Leadership Team</h3>
        </div>
        <Link onClick={() => openModal(3)}>
          <div className="lpage_div12">
            <img src="/assets/leadimg5.jpg" alt="" />
            <div className="lpage_div1_title">
              <span>Sanjay Nandrajog</span>
              <p>Chief Executive Officer</p>
            </div>
          </div>
        </Link>

        <div className="lpage_divl">
          <Link onClick={() => openModal(4)}>
            <div className="lpage_div12">
              <img src="/assets/leadimg6.jpg" alt="" />
              <div className="lpage_div1_title">
                <span>Pankaj Malik</span>
                <p>Chief Operating Officer</p>
              </div>
            </div>
          </Link>

          <Link onClick={() => openModal(5)}>
            <div className="lpage_div12">
              <img src="/assets/leadimg7.jpg" alt="" />
              <div className="lpage_div1_title">
                <span>Vineet Sirpaul</span>
                <p>Chief Corporate Sales and Acquisition</p>
                <p>Officer</p>
              </div>
            </div>
          </Link>

          <Link onClick={() => openModal(6)}>
            <div className="lpage_div13">
              <img src="/assets/leadimg8.jpg" alt="" />
              <div className="lpage_div1_title">
                <span>Kousik Gupta</span>
                <p>Chief Technology Officer</p>
              </div>
            </div>
          </Link>
        </div>

        <div className="lpage_divl">
          <Link onClick={() => openModal(7)}>
            <div className="lpage_div12">
              <img src="/assets/leadimg9.jpg" alt="" />
              <div className="lpage_div1_title">
                <span>Rakesh Ladha</span>
                <p>Chief Financial Officer</p>
              </div>
            </div>
          </Link>

          <Link onClick={() => openModal(8)}>
            <div className="lpage_div12">
              <img src="/assets/leadimg10.jpg" alt="" />
              <div className="lpage_div1_title">
                <span>Dolly Grover</span>
                <p>Chief Human Resource Officer</p>
              </div>
            </div>
          </Link>

          <Link onClick={() => openModal(9)}>
            <div className="lpage_div13">
              <img src="/assets/leadimg11.jpg" alt="" />
              <div className="lpage_div1_title">
                <span>Amit Raman Jha</span>
                <p>Chief Supply Chain Officer</p>
              </div>
            </div>
          </Link>
        </div>
      </div>
      {modals.map(
        (modal, index) =>
          modal.isOpen && (
            <Modal3
              key={index}
              closeModal={() => closeModal(index)}
              img={modal.img}
              title={modal.title}
              name={modal.name}
              about={modal.about}
            />
          )
      )}
    </div>
  );
};

export default LeadershipPage;
